import * as React from 'react';
import { StoreContext } from '../../appContext/StoreProvider/index';

const injectValues = (labelTemplate) => (v, i) => {
  const regex = new RegExp(`\\$${i + 1}`, 'g');
  labelTemplate.name = labelTemplate.name.replace(regex, v);
  labelTemplate.description = labelTemplate.description.replace(regex, v);
};

const customLabelsToTemplates =
  (templates) =>
  ({ id, values }) => {
    if (!templates[id]) {
      console.warn(
        `Trying to create label template with a id ${id}\nBut no such template is defined in viewer config.`,
      );
      return;
    }
    const labelTemplate = { ...templates[id] };
    values && values.forEach(injectValues(labelTemplate));
    return labelTemplate;
  };

export const useCustomLabelsHook = (customLabels = []) => {
  const { store } = React.useContext(StoreContext);
  const templates = store.viewer?.viewerConfig?.customLabelsTemplates;

  if (!customLabels.length) {
    return customLabels;
  }

  const labelsData = customLabels
    .map(customLabelsToTemplates(templates))
    .filter(Boolean);

  return labelsData;
};
